import React, { useState, useEffect } from "react";

const emojis = ["💻", "🖥️", "⌨️", "🖱️", "📱", "🎮", "🎧", "📡"];
const createCards = () => {
    const pairs = [...emojis, ...emojis];
    return pairs.sort(() => Math.random() - 0.5).map((emoji, index) => ({
        id: index,
        emoji,
        flipped: false,
        matched: false
    }));
};

export default function EmojiMemory() {
    const [cards, setCards] = useState(createCards());
    const [flippedCards, setFlippedCards] = useState([]);
    const [moves, setMoves] = useState(0);
    const [timeLeft, setTimeLeft] = useState(60);
    const [gameActive, setGameActive] = useState(false);
    const [gameWon, setGameWon] = useState(false);

    useEffect(() => {
        if (gameActive && timeLeft > 0 && !gameWon) {
            const timer = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
            return () => clearTimeout(timer);
        } else if (timeLeft === 0 && gameActive) {
            setGameActive(false);
        }
    }, [timeLeft, gameActive, gameWon]);

    useEffect(() => {
        if (cards.every(card => card.matched)) {
            setGameWon(true);
            setGameActive(false);
        }
    }, [cards]);

    const startGame = () => {
        setCards(createCards());
        setFlippedCards([]);
        setMoves(0);
        setTimeLeft(60);
        setGameActive(true);
        setGameWon(false);
    };

    const handleCardClick = (index) => {
        if (!gameActive || flippedCards.length === 2 || cards[index].flipped || cards[index].matched) {
            return;
        }

        const newCards = [...cards];
        newCards[index].flipped = true;
        setCards(newCards);

        const newFlipped = [...flippedCards, index];
        setFlippedCards(newFlipped);

        if (newFlipped.length === 2) {
            setMoves(moves + 1);
            const [first, second] = newFlipped;

            if (cards[first].emoji === cards[second].emoji) {
                setTimeout(() => {
                    const matched = [...cards];
                    matched[first].matched = true;
                    matched[second].matched = true;
                    setCards(matched);
                    setFlippedCards([]);
                }, 500);
            } else {
                setTimeout(() => {
                    const reset = [...cards];
                    reset[first].flipped = false;
                    reset[second].flipped = false;
                    setCards(reset);
                    setFlippedCards([]);
                }, 1000);
            }
        }
    };

    if (!gameActive && moves === 0) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"0.5rem"}}>
                    <i className="fas fa-icons" style={{marginRight:"6px"}}></i> Emoji Memory
                </h4>
                <p style={{fontSize:"0.85rem", marginBottom:"1rem"}}>
                    Trova tutte le coppie di emoji in 60 secondi!
                </p>
                <button
                    onClick={startGame}
                    style={{
                        background:"linear-gradient(135deg,#facc15,#ca8a04)",
                        border:"none",
                        color:"#000",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-play" style={{marginRight:"6px"}}></i> Inizia
                </button>
            </div>
        );
    }

    if (!gameActive && !gameWon) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1.5rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#ef4444", marginBottom:"1rem"}}>
                    <i className="fas fa-clock" style={{marginRight:"6px"}}></i> Tempo Scaduto!
                </h4>
                <p style={{fontSize:"1.2rem", fontWeight:"700", color:"#94a3b8", marginBottom:"1rem"}}>
                    Mosse: {moves}
                </p>
                <p style={{fontSize:"0.9rem", marginBottom:"1.5rem"}}>
                    ⏱️ Riprova ad essere più veloce!
                </p>
                <button
                    onClick={startGame}
                    style={{
                        background:"linear-gradient(135deg,#16a34a,#065f46)",
                        border:"none",
                        color:"#fff",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-redo" style={{marginRight:"6px"}}></i> Rigioca
                </button>
            </div>
        );
    }

    if (gameWon) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1.5rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#22c55e", marginBottom:"1rem"}}>
                    <i className="fas fa-trophy" style={{marginRight:"6px"}}></i> Hai Vinto!
                </h4>
                <p style={{fontSize:"1.5rem", fontWeight:"700", color:"#facc15", marginBottom:"1rem"}}>
                    {moves} mosse
                </p>
                <p style={{fontSize:"0.9rem", marginBottom:"1.5rem"}}>
                    {moves <= 12 && "🎉 Memoria eccezionale!"}
                    {moves > 12 && moves <= 20 && "👍 Ottimo lavoro!"}
                    {moves > 20 && "💪 Ben fatto!"}
                </p>
                <button
                    onClick={startGame}
                    style={{
                        background:"linear-gradient(135deg,#16a34a,#065f46)",
                        border:"none",
                        color:"#fff",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-redo" style={{marginRight:"6px"}}></i> Rigioca
                </button>
            </div>
        );
    }

    return (
        <div style={{
            textAlign: "center",
            padding: "1.5rem",
            color: "#e5e7eb",
            background: "rgba(255,255,255,0.05)",
            borderRadius: "1rem",
            boxShadow: "0 0 25px rgba(0,255,200,0.15)"
        }}>
            <div style={{
                display:"flex",
                justifyContent:"space-between",
                marginBottom:"1rem",
                fontSize:"0.85rem"
            }}>
                <span style={{color:"#94a3b8"}}>⏱️ {timeLeft}s</span>
                <span style={{color:"#facc15", fontWeight:"700"}}>🎯 Mosse: {moves}</span>
            </div>

            <div style={{
                display:"grid",
                gridTemplateColumns:"repeat(4, 1fr)",
                gap:"0.5rem",
                maxWidth:"220px",
                margin:"0 auto"
            }}>
                {cards.map((card, index) => (
                    <div
                        key={card.id}
                        onClick={() => handleCardClick(index)}
                        style={{
                            aspectRatio:"1",
                            display:"flex",
                            alignItems:"center",
                            justifyContent:"center",
                            fontSize:"1.8rem",
                            borderRadius:"0.5rem",
                            cursor: card.matched || card.flipped ? "default" : "pointer",
                            background: card.flipped || card.matched
                                ? "linear-gradient(135deg,#22c55e,#16a34a)"
                                : "linear-gradient(135deg,#3b82f6,#1e40af)",
                            transform: card.flipped || card.matched ? "rotateY(180deg)" : "rotateY(0deg)",
                            transition: "all 0.3s ease",
                            border: card.matched ? "2px solid #22c55e" : "2px solid rgba(255,255,255,0.1)"
                        }}
                    >
                        {(card.flipped || card.matched) ? card.emoji : "❓"}
                    </div>
                ))}
            </div>
        </div>
    );
}